document.addEventListener('DOMContentLoaded', () => {
  const marquee = document.querySelector('.marquee-container');
  const track = marquee?.querySelector('.marquee-track');

  if (!marquee || !track) return;

  // s / 100px
  const speedPer100 = parseFloat(
    marquee.dataset.speed || '1'
  );

  // 实际移动距离
  // 因为动画是 -50%
  const distance = track.scrollWidth / 2;

  // duration = (距离 / 100) × speed
  const duration = (distance / 100) * speedPer100;

  track.style.setProperty(
    '--marquee-duration',
    `${duration}s`
  );
});